/**
 * Registros versionados por acrescimo: cada versao aponta para a anterior
 * (`supersedes`), e nada e sobrescrito. Mesma regra da view
 * v_media_analysis_current, para a tela e o banco concordarem.
 */
export interface Versionado {
  id: string;
  supersedes: string | null;
  created_at: string;
  deleted_at?: string | null;
}

/**
 * A versao em vigor: nao apagada e nao substituida por outra nao apagada.
 * Se houver mais de uma (bifurcacao vinda de dois aparelhos), vale a mais
 * recente — mas o banco ja recusa bifurcacao com unique (supersedes).
 */
export function versaoAtual<T extends Versionado>(versoes: readonly T[]): T | null {
  const vivas = versoes.filter((v) => !v.deleted_at);
  const substituidas = new Set(vivas.map((v) => v.supersedes).filter((s): s is string => s != null));
  const pontas = vivas.filter((v) => !substituidas.has(v.id));
  return pontas.sort((a, b) => b.created_at.localeCompare(a.created_at))[0] ?? null;
}
